import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ResetPassword, ForgerPassword } from 'src/app/shared/interface/cit-interface';

@Injectable({
  providedIn: 'root'
})
export class CITService {
  readonly baseUrl:string=`${environment.baseUrl}`;
  readonly verifyCodeURL=`${this.baseUrl}/user/me/verifytoken`;
  readonly forgetPasswordURL=`${this.baseUrl}/user/me/forgotpassword`;
  readonly resetPasswordURL=`${this.baseUrl}/user/me/resetpassword`;
  readonly invitationURL=`${this.baseUrl}/user/invite/accept`;
  readonly invitedUserURL=`${this.baseUrl}/user/invite`;

constructor(
  private http:HttpClient
){}

forgetPassword(data:ForgerPassword):Observable<any>{
  return this.http.post<ForgerPassword>(`${this.forgetPasswordURL}`, data);
}
verifyCode(data):Observable<any>{
  return this.http.post<any>(`${this.verifyCodeURL}`, data);
}
register(data):Observable<any>{
  return this.http.post<any>(`${this.invitationURL}`, data);
}
getInvitedUser(id):Observable<any>{
  return this.http.get<any>(`${this.invitedUserURL}/${id}`);
}
resetPassword(data:ResetPassword):Observable<any>{
  return this.http.post<ResetPassword>(this.resetPasswordURL, data);
}

}
